// Reorder Console - first-load skeletons (DESIGN §6.13): header chips, three queue tiles, 8 table rows.
import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export function RcHeaderSkeleton() {
  return (
    <Box sx={{ mb: 2 }} aria-hidden="true">
      {/* the shape of the Analytics header: centred title, short bar, one-line description */}
      <Skeleton variant="text" width={260} height={40} sx={{ mx: 'auto' }} />
      <Skeleton variant="rounded" width={60} height={3} sx={{ mx: 'auto', mt: 0.5 }} />
      <Skeleton variant="text" width={380} height={18} sx={{ mx: 'auto', mb: 2 }} />
      <Stack direction="row" spacing={0.75} justifyContent="center" sx={{ flexWrap: 'wrap' }}>
        {[90, 110, 190, 150].map((w) => <Skeleton key={w} variant="rounded" width={w} height={24} sx={{ borderRadius: 3 }} />)}
      </Stack>
    </Box>
  );
}

export function RcHomeSkeleton() {
  return (
    <Box aria-busy="true" aria-label="Loading the reorder queues">
      <Skeleton variant="rounded" height={52} sx={{ maxWidth: 640, mx: 'auto', borderRadius: 3, mb: 2 }} />
      <Stack direction="row" spacing={1} justifyContent="center" sx={{ mb: 3, flexWrap: 'wrap' }}>
        {[48, 60, 76, 66, 70, 64].map((w, i) => <Skeleton key={i} variant="rounded" width={w} height={28} sx={{ borderRadius: 4 }} />)}
      </Stack>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' }, gap: 1.25, mb: 2 }}>
        {[0, 1, 2].map((i) => <Skeleton key={i} variant="rounded" height={96} sx={{ borderRadius: 2.5 }} />)}
      </Box>
      <Stack direction="row" spacing={1.25} sx={{ mb: 1.5 }}>
        {[0, 1, 2, 3].map((i) => <Skeleton key={i} variant="rounded" height={40} sx={{ flex: 1, borderRadius: 2 }} />)}
      </Stack>
      <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2.5, overflow: 'hidden' }}>
        <Skeleton variant="rectangular" height={36} />
        {Array.from({ length: 8 }).map((_, i) => (
          <Stack key={i} direction="row" spacing={2} sx={{ px: 1.5, py: 1.1, borderTop: 1, borderColor: 'divider' }}>
            <Box sx={{ flex: 3 }}>
              <Skeleton variant="text" width="45%" />
              <Skeleton variant="text" width="70%" height={14} />
            </Box>
            {[0, 1, 2, 3].map((j) => <Skeleton key={j} variant="text" sx={{ flex: 1 }} />)}
          </Stack>
        ))}
      </Box>
    </Box>
  );
}

export function RcScreenSkeleton() {
  return (
    <Box aria-busy="true" aria-label="Loading">
      <Skeleton variant="text" width={360} height={22} sx={{ mb: 1 }} />
      <Box sx={{ display: 'flex', gap: 1.75, p: 1.5, border: 1, borderColor: 'divider', borderRadius: 2.5, mb: 1.5 }}>
        <Skeleton variant="rounded" width={96} height={96} sx={{ borderRadius: 2.5, flex: '0 0 auto' }} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="40%" height={30} />
          <Skeleton variant="text" width="75%" />
          <Skeleton variant="text" width="55%" />
        </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2,1fr)', md: 'repeat(4,1fr)' }, gap: 1, mb: 1.5 }}>
        {[0, 1, 2, 3].map((i) => <Skeleton key={i} variant="rounded" height={64} sx={{ borderRadius: 2 }} />)}
      </Box>
      <Skeleton variant="rounded" height={260} sx={{ borderRadius: 2.5 }} />
    </Box>
  );
}

// Suspense fallback of the route (while the console's code chunk loads).
export default function RcPageSkeleton() {
  return (
    <Box sx={{ p: { xs: 1.5, md: 3 }, maxWidth: 1500, mx: 'auto' }}>
      <RcHeaderSkeleton />
      <RcHomeSkeleton />
    </Box>
  );
}
